import DatePicker from "react-datepicker";
var moment = require('moment');
import { DateRangePicker, createStaticRanges } from 'react-date-range';
import OutsideAlerter from '../General/OutsideAlerter';
import ReactModal from "react-modal";
import $ from "jquery";
import React from 'react';
import { AbconetApi } from '../General/AbconetApi';

var ScheduleSelector = require('../General/Selectors/ScheduleSelector').ScheduleSelector;

import {
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
    addQuarters,
    subYears,
    } from 'date-fns';
import { isNullOrUndefined } from "util";
import { startOfQuarter, endOfQuarter, startOfYear } from "date-fns/esm";
import { startOfQuarterWithOptions } from "date-fns/esm/fp";

const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),

    startOfThisQuarter: startOfQuarter(new Date()),
    endOfThisQuarter: endOfQuarter(new Date()),

    startOfLastQuarter: startOfQuarter(addQuarters(new Date(), -1)),
    endOfLastQuarter: endOfQuarter(addQuarters(new Date(), -1)),

    startOfYear: startOfYear(new Date()),

    startOfFinancialYear: (new Date()).getMonth() <= 6 ? new Date(new Date().getFullYear()-1, 6, 1) : new Date(new Date().getFullYear(), 6, 1)
};


var reportList = [
    {
        name: 'Operations Report',
        type: 'operations',
        description: 'This report will show you the information on site, including purchases, recharge amount, and budget. {date}.',
        options: [
            {
                label:'Period',
                name:'date',
                type: 'DateSelector',
                monthOnly: true,
                predefinedRanges: createStaticRanges([
                    {
                        label: 'This Month',
                        range: () => ({
                            startDate: defineds.startOfMonth,
                            endDate: defineds.endOfMonth
                        })
                    },
                    {
                        label: 'Last Month',
                        range: () => ({
                            startDate: defineds.startOfLastMonth,
                            endDate: defineds.endOfLastMonth
                        })
                    }
                ])
            }
        ]
    },
    {
        name: 'Purchases Report',
        type: 'purchases',
        description: 'List all purchases for {date}',
        options: [
            {
                label: 'Period',
                name: 'date',
                type: 'DateSelector',
                predefinedRanges: createStaticRanges([
                    {
                        label: 'Yesterday',
                        range: () => ({
                            startDate: defineds.startOfYesterday,
                            endDate: defineds.endOfYesterday
                        })
                    },
                    {
                        label: 'This Week',
                        range: () => ({
                            startDate: defineds.startOfWeek,
                            endDate: defineds.endOfWeek
                        })
                    },
                    {
                        label: 'Last Week',
                        range: () => ({
                            startDate: defineds.startOfLastWeek,
                            endDate: defineds.endOfLastWeek
                        })
                    },
                    {
                        label: 'This Month',
                        range: () => ({
                            startDate: defineds.startOfMonth,
                            endDate: defineds.endOfMonth
                        })
                    },
                    {
                        label: 'Last Month',
                        range: () => ({
                            startDate: defineds.startOfLastMonth,
                            endDate: defineds.endOfLastMonth
                        })
                    },
                    {
                        label: 'This Quarter',
                        range: () => ({
                            startDate: defineds.startOfThisQuarter,
                            endDate: defineds.endOfThisQuarter
                        })
                    },
                    {
                        label: 'Last Quarter',
                        range: () => ({
                            startDate: defineds.startOfLastQuarter,
                            endDate: defineds.endOfLastQuarter
                        })
                    },
                    {
                        label: 'Year to Date',
                        range: () => ({
                            startDate: defineds.startOfYear,
                            endDate: defineds.endOfToday
                        })
                    },
                    {
                        label: 'Financial Year to Date',
                        range: () => ({
                            startDate: defineds.startOfFinancialYear,
                            endDate: defineds.endOfToday
                        })
                    }
                ])
            }
        ]
    },
    {
        name: 'Stock Usage and Expenditure By Site',
        type: 'stockusagebysite',
        description: 'List of stock usage and expenditures grouped by site for {date}',
        requiredNumberOfAddress: 2,
        options: [
            {
                label: 'Period',
                name: 'date',
                type: 'DateSelector',
                predefinedRanges: createStaticRanges([
                    {
                        label: 'Yesterday',
                        range: () => ({
                            startDate: defineds.startOfYesterday,
                            endDate: defineds.endOfYesterday
                        })
                    },
                    {
                        label: 'This Week',
                        range: () => ({
                            startDate: defineds.startOfWeek,
                            endDate: defineds.endOfWeek
                        })
                    },
                    {
                        label: 'Last Week',
                        range: () => ({
                            startDate: defineds.startOfLastWeek,
                            endDate: defineds.endOfLastWeek
                        })
                    },
                    {
                        label: 'This Month',
                        range: () => ({
                            startDate: defineds.startOfMonth,
                            endDate: defineds.endOfMonth
                        })
                    },
                    {
                        label: 'Last Month',
                        range: () => ({
                            startDate: defineds.startOfLastMonth,
                            endDate: defineds.endOfLastMonth
                        })
                    },
                    {
                        label: 'This Quarter',
                        range: () => ({
                            startDate: defineds.startOfThisQuarter,
                            endDate: defineds.endOfThisQuarter
                        })
                    },
                    {
                        label: 'Last Quarter',
                        range: () => ({
                            startDate: defineds.startOfLastQuarter,
                            endDate: defineds.endOfLastQuarter
                        })
                    },
                    {
                        label: 'Year to Date',
                        range: () => ({
                            startDate: defineds.startOfYear,
                            endDate: defineds.endOfToday
                        })
                    },
                    {
                        label: 'Financial Year to Date',
                        range: () => ({
                            startDate: defineds.startOfFinancialYear,
                            endDate: defineds.endOfToday
                        })
                    }
                ])
            }
        ]
    },
    {
        name: 'Stock Usage and Expenditure By Site and By Month',
        type: 'stockusagebysitebymonth',
        description: 'List of stock usage and expenditures grouped by site and by month for {date}',
        requiredNumberOfAddress:  2,
        options: [
            {
                label: 'Period',
                name: 'date',
                type: 'DateSelector',
                predefinedRanges: createStaticRanges([
                    {
                        label: 'Yesterday',
                        range: () => ({
                            startDate: defineds.startOfYesterday,
                            endDate: defineds.endOfYesterday
                        })
                    },
                    {
                        label: 'This Week',
                        range: () => ({
                            startDate: defineds.startOfWeek,
                            endDate: defineds.endOfWeek
                        })
                    },
                    {
                        label: 'Last Week',
                        range: () => ({
                            startDate: defineds.startOfLastWeek,
                            endDate: defineds.endOfLastWeek
                        })
                    },
                    {
                        label: 'This Month',
                        range: () => ({
                            startDate: defineds.startOfMonth,
                            endDate: defineds.endOfMonth
                        })
                    },
                    {
                        label: 'Last Month',
                        range: () => ({
                            startDate: defineds.startOfLastMonth,
                            endDate: defineds.endOfLastMonth
                        })
                    },
                    {
                        label: 'This Quarter',
                        range: () => ({
                            startDate: defineds.startOfThisQuarter,
                            endDate: defineds.endOfThisQuarter
                        })
                    },
                    {
                        label: 'Last Quarter',
                        range: () => ({
                            startDate: defineds.startOfLastQuarter,
                            endDate: defineds.endOfLastQuarter
                        })
                    },
                    {
                        label: 'Year to Date',
                        range: () => ({
                            startDate: defineds.startOfYear,
                            endDate: defineds.endOfToday
                        })
                    },
                    {
                        label: 'Financial Year to Date',
                        range: () => ({
                            startDate: defineds.startOfFinancialYear,
                            endDate: defineds.endOfToday
                        })
                    }
                ])
            }
        ]
    },
    {
        name: 'Rechargeable Items',
        type: 'rechargeableitems',
        description: 'List rechargeable items for {date}',
        options: [
            {
                label: 'Period',
                name: 'date',
                type: 'DateSelector',
                predefinedRanges: createStaticRanges([
                    {
                        label: 'Yesterday',
                        range: () => ({
                            startDate: defineds.startOfYesterday,
                            endDate: defineds.endOfYesterday
                        })
                    },
                    {
                        label: 'This Week',
                        range: () => ({
                            startDate: defineds.startOfWeek,
                            endDate: defineds.endOfWeek
                        })
                    },
                    {
                        label: 'Last Week',
                        range: () => ({
                            startDate: defineds.startOfLastWeek,
                            endDate: defineds.endOfLastWeek
                        })
                    },
                    {
                        label: 'This Month',
                        range: () => ({
                            startDate: defineds.startOfMonth,
                            endDate: defineds.endOfMonth
                        })
                    },
                    {
                        label: 'Last Month',
                        range: () => ({
                            startDate: defineds.startOfLastMonth,
                            endDate: defineds.endOfLastMonth
                        })
                    },
                    {
                        label: 'This Quarter',
                        range: () => ({
                            startDate: defineds.startOfThisQuarter,
                            endDate: defineds.endOfThisQuarter
                        })
                    },
                    {
                        label: 'Last Quarter',
                        range: () => ({
                            startDate: defineds.startOfLastQuarter,
                            endDate: defineds.endOfLastQuarter
                        })
                    },
                    {
                        label: 'Year to Date',
                        range: () => ({
                            startDate: defineds.startOfYear,
                            endDate: defineds.endOfToday
                        })
                    },
                    {
                        label: 'Financial Year to Date',
                        range: () => ({
                            startDate: defineds.startOfFinancialYear,
                            endDate: defineds.endOfToday
                        })
                    }
                ])
            }
        ]
    },
    {
        name: 'Backorders',
        type: 'backorders',
        description: 'This report will show any items on backorder.',
        options: []
    },
    {
        name: 'Difot Report',
        type: 'difot',
        description: 'List all difot for {date}',
        options: [
            {
                label: 'Period',
                name: 'date',
                type: 'DateSelector',
                predefinedRanges: createStaticRanges([
                    {
                        label: 'Yesterday',
                        range: () => ({
                            startDate: defineds.startOfYesterday,
                            endDate: defineds.endOfYesterday
                        })
                    },
                    {
                        label: 'This Week',
                        range: () => ({
                            startDate: defineds.startOfWeek,
                            endDate: defineds.endOfWeek
                        })
                    },
                    {
                        label: 'Last Week',
                        range: () => ({
                            startDate: defineds.startOfLastWeek,
                            endDate: defineds.endOfLastWeek
                        })
                    },
                    {
                        label: 'This Month',
                        range: () => ({
                            startDate: defineds.startOfMonth,
                            endDate: defineds.endOfMonth
                        })
                    },
                    {
                        label: 'Last Month',
                        range: () => ({
                            startDate: defineds.startOfLastMonth,
                            endDate: defineds.endOfLastMonth
                        })
                    },
                    {
                        label: 'This Quarter',
                        range: () => ({
                            startDate: defineds.startOfThisQuarter,
                            endDate: defineds.endOfThisQuarter
                        })
                    },
                    {
                        label: 'Last Quarter',
                        range: () => ({
                            startDate: defineds.startOfLastQuarter,
                            endDate: defineds.endOfLastQuarter
                        })
                    },
                    {
                        label: 'Year to Date',
                        range: () => ({
                            startDate: defineds.startOfYear,
                            endDate: defineds.endOfToday
                        })
                    },
                    {
                        label: 'Financial Year to Date',
                        range: () => ({
                            startDate: defineds.startOfFinancialYear,
                            endDate: defineds.endOfToday
                        })
                    }
                ])
            }
        ]
    }
];



class ReportDateSelector extends React.Component {

    constructor(props) {
        super(props);
        var selectedRange = [
            {
                startDate: defineds.startOfLastMonth,
                endDate: defineds.endOfLastMonth,
                key: 'selection'
            }
        ];
        this.state = {
            dateRangeShown: false,
            selectedData: {
                ranges: selectedRange,
                selectedPredefinedRange: this.getSelectedRangeFromSelection(selectedRange)
            }
        }
    }

    isRangeSelected(ranges, staticRange) {
        const focusedRangeIndex = ranges.findIndex(range => {
            if (!range.startDate || !range.endDate || range.disabled) return false;
            return staticRange.isSelected(range);
        });

        return { isSelected: !Boolean(focusedRangeIndex) };
    }

    getSelectedRangeFromSelection(ranges) {
        var selected;
        this.props.predefinedRanges.map((staticRange, i) => {
            const { isSelected } = this.isRangeSelected(ranges, staticRange);
            if (isSelected) {
                selected = staticRange;
            }
        });

        return selected;
    }

    handleSelect(calendar) {
        

        var selectedData = {
            selectedPredefinedRange: this.getSelectedRangeFromSelection([calendar.selection]),
            ranges:
                [calendar.selection]
        }

        var self = this;
        this.setState({
            selectedData: selectedData
        }, function() {
            self.props.onChange({
                reportValue: this.getReportValue(),
                displayValue: this.formatSelection(true)
            });
        });


        
    }

    componentDidMount() {
        this.props.onChange({
            reportValue: this.getReportValue(),
            displayValue: this.formatSelection(true)
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.props.onChange({
                reportValue: this.getReportValue(),
                displayValue: this.formatSelection(true)
            });
        }
    }

    openDateRange() {
        this.setState({ dateRangeShown: true });
    }

    closeDateRange() {
        this.setState({ dateRangeShown: false });
    }

    getReportValue() {
        var returnObj = {
            startDate: moment(this.state.selectedData.ranges[0].startDate).format('YYYY-MM-DD')
        }

        if (!this.props.monthOnly) {
            returnObj.endDate = moment(this.state.selectedData.ranges[0].endDate).format('YYYY-MM-DD');
        }

        return returnObj;
    }

    formatSelection(doLowerCase) {
        if (this.state.selectedData.selectedPredefinedRange != null) {
            if (doLowerCase) {
                return this.state.selectedData.selectedPredefinedRange.label.toLowerCase();
            } else {
                return this.state.selectedData.selectedPredefinedRange.label;
            }
        }

        if (this.state.selectedData.ranges[0] != null) {
            if (this.props.monthOnly) {
                return moment(this.state.selectedData.ranges[0].startDate).format('MMM YYYY');
            }

            if (this.state.selectedData.ranges[0].startDate == this.state.selectedData.ranges[0].endDate) {
                return moment(this.state.selectedData.ranges[0].startDate).format('DD MMM YYYY');
            }

            return moment(this.state.selectedData.ranges[0].startDate).format('DD MMM YYYY') + " to " + moment(this.state.selectedData.ranges[0].endDate).format('DD MMM YYYY');
        }

        return "";
    }

    render() {
        var dateRange;
        if (this.state.dateRangeShown) {
            dateRange = <DateRangePicker
                            ranges={this.state.selectedData.ranges}
                            staticRanges={this.props.predefinedRanges}
                            onChange={this.handleSelect.bind(this)}
                            maxDate={new Date()}
                            inputRanges={[]}
                            className="abco-date-range"/>;
        }

        return (
            <div>
                <OutsideAlerter handleClickOutside={this.closeDateRange.bind(this)}>
                    <input className="form-control" type="text" placeholder="Please select a date" value={this.formatSelection()} readOnly="readonly" onFocus={this.openDateRange.bind(this)} />
                    {dateRange}
                </OutsideAlerter>
            </div>
        );

    }
}



export class ReportSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cronText: '',
            selectedReport: '',
            scheduleModalOpen: false,
            reportSchedule: null,
            isSaved: true,
            isSaving: false,
            addressCount: props.addressCount
        };
    }

    openScheduleModal(ev) {    
        ev.preventDefault();
        this.getReportSchedule();
        this.setState({
            scheduleModalOpen: true
        });
    }
    
    closeScheduleModal() {
        this.setState({
            scheduleModalOpen: false
        });
    }

    createSchedule() {
        var self = this;
        var selectedReport = this.getSelectedReport();
        var period;

        if (selectedReport.type == 'backorders') {
            period = '';
        } else {
            period = this.state.date.displayValue;
        }

        var timezoneOffset = new Date().getTimezoneOffset();
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log('timezone', timezone);

        var scheduleReportDto = {
            expression: this.state.cronText,
            reportName: selectedReport.type,
            period: period,
            timezone: timezone
        };

        console.log('scheduleReportDto', scheduleReportDto);

        this.setState({ isSaving: true });

        fetch('/api/report/schedule', {
            method: 'POST',
            body: JSON.stringify(scheduleReportDto),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response.json();
            }).then(function (response) {
                setTimeout(
                    () => {
                        self.setState({ isSaved: true, isSaving: false });

                        setTimeout(() => {
                            self.closeScheduleModal();
                            $(document).trigger("ReportScheduleAdded");
                        },
                            300);
                    },
                    200);
        });
    }

    handleChange (event) {
         this.setState({ selectedReport: event.target.value });
    }

    generateReport(ev) {
        var selectedReport = this.getSelectedReport();

        ev.preventDefault();
        var data = {
            reportType: selectedReport.type
        };
        
        for (var i = 0; i < selectedReport.options.length; i++) {
            var option = selectedReport.options[i];
            if (option.name === 'date') {
                data.startDate = this.state[option.name].reportValue.startDate;
                data.endDate = this.state[option.name].reportValue.endDate;
            } else {
                data[option.name] = this.state[option.name].reportValue;
            }

            
        }

        AbconetApi.get("/api/report" + "?" + $.param(data)).then(response => {
        })

        $(document).trigger("AlertUpdated", {
            type: 'primary',
            message: 'Your requested report will be processed and sent to your email. Thank you.'
        });
    }


    getReportSchedule() {
        var self = this;
        var selectedReport = this.getSelectedReport();

        fetch('/api/report/' + selectedReport.type + '/schedule', {
            method: 'GET',
            body: null,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response.json();
        }).then(function (response) {
            self.setState({
                reportSchedule: response,
            });
        });
    }

    handleOptionChange(key, value) {
        var updateObject = {};
        updateObject[key] = value;
        this.setState(updateObject);
    }

    getSelectedReport() {
        for (var i = 0; i < reportList.length; i++) {
            if (this.state.selectedReport === reportList[i].name) {
                return reportList[i];
            }
        }

        return null;
    }

    renderOption(option) {
        var element;
        switch (option.type) {
            case 'DateSelector':
                element = <ReportDateSelector {...option} onChange={this.handleOptionChange.bind(this, option.name)} value={this.state[option.name]} report={this.getSelectedReport().name} />;
                break;
        }

        if (element) {
            return <div className="form-group row">
                        <label className="col-sm-2 col-form-label">{option.label}</label>
                        <div className="col-sm-10">
                            {element}
                        </div>
                   </div>;
        }
    }

    getDescription(selectedReport) {
        var description = selectedReport.description;

        if (this.state.date) {
            description = description.replace('{date}', this.state.date.displayValue);
        }

        return description;
    }

    updateSchedule(cron) {
        this.setState({
            cronText: cron
        });

        if (isNullOrUndefined(cron)) {
            this.setState({
                isSaved: true
            });
        } else {
            this.setState({
                isSaved: false
            });
        }

    }

    renderCreateScheduleButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        if (isNullOrUndefined(this.state.cronText)) {
            btnText = 'Save';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving} onClick={this.createSchedule.bind(this)}>{btnText}</button>;
        
    }

    render() {
        var selectedReport = this.getSelectedReport();
        var card;
        var options;
        var self = this;
        if (selectedReport == null) {
            card = <div className="card">
                       <div className="card-body">
                           <h5 className="card-title">Report</h5>
                           <h6 className="card-subtitle mb-2 text-muted"></h6>
                           <p className="card-text">Please select a report.</p>
                       </div>
                   </div>
        } else {
            card = <div className="card">
                       <div className="card-body">
                           <h6 className="card-subtitle mb-2 text-muted">{selectedReport.name}</h6>
                           <p className="card-text">{this.getDescription(selectedReport)}</p>
                           <a href="#" onClick={this.generateReport.bind(this)} className="card-link btn btn-primary">Generate</a>
                           <a href="#" className="card-link" onClick={this.openScheduleModal.bind(this)}>Subscribe</a>
                       </div>
            </div>;
            options = selectedReport.options.map(this.renderOption.bind(this));
        }

        return (
            <div className="report-selector">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="form-group row">
                                <label htmlFor="reportType" className="col-sm-2 col-form-label">Report</label>
                       
                                <div className="col-sm-10">
                                    <select value={this.state.selectedReport} onChange={this.handleChange.bind(this)} className="form-control">
                                        <option />
                                        {/*reportList.map(x => <option>{x.name}</option>)*/}

                                        {reportList.map(function (report) {
                                            if (self.state.addressCount >= report.requiredNumberOfAddress ) {
                                                return <option>{report.name}</option>
                                            }

                                            if (isNullOrUndefined(report.requiredNumberOfAddress)) {
                                                return <option>{report.name}</option>
                                            }
                                        })}
                                    </select>
                                </div>
                            </div>
                            {options}
                        </div>
                        <div className="col-lg-6">
                            {card}
                        </div>
                    </div>
                </div>
                <ReactModal isOpen={this.state.scheduleModalOpen} onRequestClose={this.closeScheduleModal.bind(this)} portalClassName="modal-portal" className="modal-dialog schedule-modal" overlayClassName="modal" bodyOpenClassName="modal-open" >
                    <div className="modal-content">
                        <div className="bd p-15">
                            <h5 className="m-0">Schedule</h5>
                        </div>
                        <div className="modal-body">
                            <ScheduleSelector onChange={this.updateSchedule.bind(this)}/>
                            <div>
                                {this.renderCreateScheduleButton()}
                            </div>
                        </div>
                        <button onClick={this.closeScheduleModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                    </div>
                </ReactModal>
            </div>
        );

    }
}